export default "__VITE_ASSET__D4ctcfar__"